// List of the product info

import bike1 from "./assets/products/bike1.webp"
import bike3 from "./assets/products/bike3.jpg"
import bike4 from "./assets/products/bike4.jpeg"
import bike5 from "./assets/products/bike5.png"
import bike6 from "./assets/products/bike6.png"
import bike7 from "./assets/products/bike7.png"
import bike8 from "./assets/products/bike8.png"
import bike9 from "./assets/products/bike9.png"
import bike10 from "./assets/products/bike10.jpg"
import bike11 from "./assets/products/bike11.jpg"
import bike12 from "./assets/products/bike12.webp"
import helmet1 from './assets/products/helmet1.webp'
import helmet2 from './assets/products/helmet2.webp'
import helmet3 from './assets/products/helmet3.jpeg'
import helmet4 from './assets/products/helmet4.jpg'
import helmet5 from './assets/products/helmet5.jpg'
import helmet6 from './assets/products/helmet6.webp'
import botHold1 from './assets/products/botHold1.jpg'
import botHold2 from './assets/products/botHold2.jpg'
import botHold3 from './assets/products/botHold3.jpg'

export const PRODUCTS =[
    {
        id: 1,
        productName: 'Montra Helicon X - Road',
        price: 19000,
        productImg: bike1,
        category:'Road bike bicycle',
        // description: {
            brand: 'Montra',
            color: 'blue',
            weight: 16,
            materials: ['Carbon Fibre','steel'],
            frame: 'With a 17.5” seat tube, the AV1 frame comes with 26” & 27.5” to suit your need. The frame geometry with 22.5” reach sets the rider at a comfortable yet controlled position for high maneuverability. The structure of the frame with the tapered down tube and flat top tube provides high strength and lightweight which is crucial for a great mountain bike.',
            crank: 'The 2-speed Prowheel heavy-duty crank allows you to switch between medium-speed low power and low-speed high power for flats, low to high steeps, and rough terrains without compromising efficiency.',
            videoSrc:"https://www.youtube.com/embed/i-afDOw26MA", 
            // 'https://www.youtube.com/watch?v=iVINW3qsVU8&ab_channel=ChooseMyBicycle',
            otherDesc: "Perfect for climbing, riding, skiing, cave exploration, outward bound training, etc. Made of premium quality EPS, shockproof and wear resistance, super durable and very light to wear. The outer hard inner soft structure can effectively disperse the external force and absorb the impact force. Protecting the safety of the user's life. Rotate the adjusting roll to adjust size and fit your head size, convenient for you."
        // }

    },
    {
        id: 2,
        productName: 'Firefox Roadpro',
        price: 19999,
        productImg: bike3,
        category:'Road bike bicycle',
        // description: {
            brand: 'Firefox',
            color: 'blue',
            weight: 15,
            materials: ['Carbon Fibre','steel'],
            frame: 'With a 17.5” seat tube, the AV1 frame comes with 26” & 27.5” to suit your need. The frame geometry with 22.5” reach sets the rider at a comfortable yet controlled position for high maneuverability. The structure of the frame with the tapered down tube and flat top tube provides high strength and lightweight which is crucial for a great mountain bike.',
            crank: 'The 2-speed Prowheel heavy-duty crank allows you to switch between medium-speed low power and low-speed high power for flats, low to high steeps, and rough terrains without compromising efficiency.',
            videoSrc: 'https://www.youtube.com/embed/eFQ2x2yF1dU',
            otherDesc: "The MTB frame is ergonomically designed to handle tough terrains, with shaped tubes that measure 18``. The cycle has a steel double-bend type handle bar, the stem of which is made of an alloy. The cycle also has a threadless type Neco head fitting. Brake type: V Brake or Power Brake. Fork Type - Rigid. The cycle has an Steel wheel with a black rim. Plastic anti-skid body reflectorised pedals ensure a stylish look while making pedalling a comfortable and safe experience. Installation & assembly service available"
        // }
    },
    {
        id: 3,
        productName: 'Hero Hawk - Road',
        price: 20999,
        productImg: bike4,
        category:'Road bike bicycle',
        // description: {
            brand: 'Firefox',
            color: 'gray',
            weight: 17,
            materials: ['Carbon Fibre','steel'],
            frame: 'With a 17.5” seat tube, the AV1 frame comes with 26” & 27.5” to suit your need. The frame geometry with 22.5” reach sets the rider at a comfortable yet controlled position for high maneuverability. The structure of the frame with the tapered down tube and flat top tube provides high strength and lightweight which is crucial for a great mountain bike.',
            crank: 'The 2-speed Prowheel heavy-duty crank allows you to switch between medium-speed low power and low-speed high power for flats, low to high steeps, and rough terrains without compromising efficiency.',
            videoSrc: 'https://www.youtube.com/embed/hFnWvDw_-_M',
            otherDesc: "The MTB frame is ergonomically designed to handle tough terrains, with shaped tubes that measure 18``. The cycle has a steel double-bend type handle bar, the stem of which is made of an alloy. The cycle also has a threadless type Neco head fitting. Brake type: V Brake or Power Brake. Fork Type - Rigid. The cycle has an Steel wheel with a black rim. Plastic anti-skid body reflectorised pedals ensure a stylish look while making pedalling a comfortable and safe experience. Installation & assembly service available"
        // }

    },
    {
        id: 4,
        productName: 'Montra Trance - Hybrid',
        price: 31999,
        productImg: bike5,
        category:'Hybrid bike bicycle',
        // description: {
            brand: 'Firefox',
            color: 'blue',
            weight: 15,
            materials: ['Carbon Fibre','steel'],
            frame: 'With a 17.5” seat tube, the AV1 frame comes with 26” & 27.5” to suit your need. The frame geometry with 22.5” reach sets the rider at a comfortable yet controlled position for high maneuverability. The structure of the frame with the tapered down tube and flat top tube provides high strength and lightweight which is crucial for a great hybrid bike.',
            crank: 'The 2-speed Prowheel heavy-duty crank allows you to switch between medium-speed low power and low-speed high power for flats, low to high steeps, and rough terrains without compromising efficiency.',
            videoSrc: 'https://www.youtube.com/embed/1lS2c6TuTp4',
            otherDesc: "The hybrid bike frame is ergonomically designed to handle smooth or gravel streets, with shaped tubes that measure 18``. The cycle has a steel single-bend type handle bar, the stem of which is made of an alloy. The cycle also has a threadless type Neco head fitting. Brake type: V Brake or Power Brake. Fork Type - Rigid. The cycle has an Steel wheel with a black rim. Plastic anti-skid body reflectorised pedals ensure a stylish look while making pedalling a comfortable and safe experience. Installation & assembly service available"
        // }

    },
    {
        id: 5,
        productName: 'Hero Octane - Hybrid',
        price: 26508,
        productImg: bike6,
        category:'Hybrid bike bicycle',
        // description: {
            brand: 'Firefox',
            color: 'blue',
            weight: 15,
            materials: ['Carbon Fibre','steel'],
            frame: 'With a 17.5” seat tube, the AV1 frame comes with 26” & 27.5” to suit your need. The frame geometry with 22.5” reach sets the rider at a comfortable yet controlled position for high maneuverability. The structure of the frame with the tapered down tube and flat top tube provides high strength and lightweight which is crucial for a great mountain bike.',
            crank: 'The 2-speed Prowheel heavy-duty crank allows you to switch between medium-speed low power and low-speed high power for flats, low to high steeps, and rough terrains without compromising efficiency.',
            videoSrc: 'https://www.youtube.com/embed/pj1Dtd-FM7A',
            otherDesc: "The hybrid frame is ergonomically designed to handle tough terrains, with shaped tubes that measure 18``. The cycle has a steel double-bend type handle bar, the stem of which is made of an alloy. The cycle also has a threadless type Neco head fitting. Brake type: V Brake or Power Brake. Fork Type - Rigid. The cycle has an Steel wheel with a black rim. Plastic anti-skid body reflectorised pedals ensure a stylish look while making pedalling a comfortable and safe experience. Installation & assembly service available"
        // }'
        // <iframe width="560" height="315" src="https://www.youtube.com/embed/eFQ2x2yF1dU" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>

    },
    {
        id: 6,
        productName: 'Firefox Meteor 700c - hybrid',
        price: 14654,
        productImg: bike7,
        category:'Hybrid bike bicycle',
        // description: {
            brand: 'Firefox',
            color: 'blue',
            weight: 15,
            materials: ['Carbon Fibre','steel'],
            frame: 'With a 17.5” seat tube, the AV1 frame comes with 26” & 27.5” to suit your need. The frame geometry with 22.5” reach sets the rider at a comfortable yet controlled position for high maneuverability. The structure of the frame with the tapered down tube and flat top tube provides high strength and lightweight which is crucial for a great mountain bike.',
            crank: 'The 2-speed Prowheel heavy-duty crank allows you to switch between medium-speed low power and low-speed high power for flats, low to high steeps, and rough terrains without compromising efficiency.',
            videoSrc: 'https://www.youtube.com/embed/glJFJX3ooig',
            otherDesc: "The MTB frame is ergonomically designed to handle tough terrains, with shaped tubes that measure 18``. The cycle has a steel double-bend type handle bar, the stem of which is made of an alloy. The cycle also has a threadless type Neco head fitting. Brake type: V Brake or Power Brake. Fork Type - Rigid. The cycle has an Steel wheel with a black rim. Plastic anti-skid body reflectorised pedals ensure a stylish look while making pedalling a comfortable and safe experience. Installation & assembly service available"
        // }

    },
    {
        id: 7,
        productName: 'Montra Madrock - Mountain',
        price: 17900,
        productImg: bike10,
        category:'Mountain bike bicycle',
        // description: {
            brand: 'Firefox',
            color: 'blue',
            weight: 15,
            materials: ['Carbon Fibre','steel'],
            frame: 'With a 17.5” seat tube, the AV1 frame comes with 26” & 27.5” to suit your need. The frame geometry with 22.5” reach sets the rider at a comfortable yet controlled position for high maneuverability. The structure of the frame with the tapered down tube and flat top tube provides high strength and lightweight which is crucial for a great mountain bike.',
            crank: 'The 2-speed Prowheel heavy-duty crank allows you to switch between medium-speed low power and low-speed high power for flats, low to high steeps, and rough terrains without compromising efficiency.',
            videoSrc: 'https://www.youtube.com/embed/iVINW3qsVU8',
            otherDesc: "The MTB frame is ergonomically designed to handle tough terrains, with shaped tubes that measure 18``. The cycle has a steel double-bend type handle bar, the stem of which is made of an alloy. The cycle also has a threadless type Neco head fitting. Brake type: V Brake or Power Brake. Fork Type - Rigid. The cycle has an Steel wheel with a black rim. Plastic anti-skid body reflectorised pedals ensure a stylish look while making pedalling a comfortable and safe experience. Installation & assembly service available"
        // }

    },
    {
        id: 8,
        productName: 'Firefox Stravaro 29er - Mountain',
        price: 10000,
        productImg: bike11,
        category:'Mountain bike bicycle',
        // description: {
            brand: 'Firefox',
            color: 'blue',
            weight: 14,
            materials: ['Carbon Fibre','steel'],
            frame: 'With a 17.5” seat tube, the AV1 frame comes with 26” & 27.5” to suit your need. The frame geometry with 22.5” reach sets the rider at a comfortable yet controlled position for high maneuverability. The structure of the frame with the tapered down tube and flat top tube provides high strength and lightweight which is crucial for a great mountain bike.',
            crank: 'The 2-speed Prowheel heavy-duty crank allows you to switch between medium-speed low power and low-speed high power for flats, low to high steeps, and rough terrains without compromising efficiency.',
            videoSrc: 'https://www.youtube.com/embed/p2Yo-n7yRN8',
            otherDesc: "The MTB frame is ergonomically designed to handle tough terrains, with shaped tubes that measure 18``. The cycle has a steel double-bend type handle bar, the stem of which is made of an alloy. The cycle also has a threadless type Neco head fitting. Brake type: V Brake or Power Brake. Fork Type - Rigid. The cycle has an Steel wheel with a black rim. Plastic anti-skid body reflectorised pedals ensure a stylish look while making pedalling a comfortable and safe experience. Installation & assembly service available"
        // }

    },
    {
        id: 9,
        productName: 'Hero Sprint Pro Trans 26T - Mountain',
        price: 25000,
        productImg: bike12,
        category:'Mountain bike bicycle',
        // description: {
            brand: 'Firefox',
            color: 'blue',
            weight: 12,
            materials: ['Carbon Fibre','steel'],
            frame: 'With a 17.5” seat tube, the AV1 frame comes with 26” & 27.5” to suit your need. The frame geometry with 22.5” reach sets the rider at a comfortable yet controlled position for high maneuverability. The structure of the frame with the tapered down tube and flat top tube provides high strength and lightweight which is crucial for a great mountain bike.',
            crank: 'The 2-speed Prowheel heavy-duty crank allows you to switch between medium-speed low power and low-speed high power for flats, low to high steeps, and rough terrains without compromising efficiency.',
            videoSrc: 'https://www.youtube.com/embed/XEFvJylPAQY',
            otherDesc: "The MTB frame is ergonomically designed to handle tough terrains, with shaped tubes that measure 18``. The cycle has a steel double-bend type handle bar, the stem of which is made of an alloy. The cycle also has a threadless type Neco head fitting. Brake type: V Brake or Power Brake. Fork Type - Rigid. The cycle has an Steel wheel with a black rim. Plastic anti-skid body reflectorised pedals ensure a stylish look while making pedalling a comfortable and safe experience. Installation & assembly service available"
        // }

    },
    {
        id: 10,
        productName: 'Prowel F59R ',
        price: 445,
        productImg: helmet1,
        category:'Helmet',
        // description: {
            brand: 'Firefox',
            color: 'blue',
            weight: 0.51,
            materials: ['Carbon Fibre','plastic'],
            frame: null,
            crank: null,
            videoSrc: 'https://www.youtube.com/embed/lRfyuiVVHhc',
            otherDesc: "Perfect for climbing, riding, skiing, cave exploration, outward bound training, etc. Made of premium quality EPS, shockproof and wear resistance, super durable and very light to wear. The outer hard inner soft structure can effectively disperse the external force and absorb the impact force. Protecting the safety of the user's life. Rotate the adjusting roll to adjust size and fit your head size, convenient for you."

        // }

    },
    {
        id: 11,
        productName: 'Prowell BCD321',
        price: 680,
        productImg: helmet2,
        category:'Helmet',
        // description: {
            brand: 'Firefox',
            color: 'blue',
            weight: 0.315,
            materials: ['Carbon Fibre','plastic'],
            frame: null,
            crank: null,
            videoSrc: 'https://www.youtube.com/embed/lRfyuiVVHhc',
            otherDesc: "Perfect for climbing, riding, skiing, cave exploration, outward bound training, etc. Made of premium quality EPS, shockproof and wear resistance, super durable and very light to wear. The outer hard inner soft structure can effectively disperse the external force and absorb the impact force. Protecting the safety of the user's life. Rotate the adjusting roll to adjust size and fit your head size, convenient for you."

        // }

    },
    {
        id: 12,
        productName: 'Firefox Hell-mate',
        price: 500,
        productImg: helmet3,
        category:'Helmet',
        // description: {
            brand: 'Firefox',
            color: 'blue',
            weight: 0.5,
            materials: ['Carbon Fibre','plastic'],
            frame: null,
            crank: null,
            videoSrc: 'https://www.youtube.com/embed/DILRkwO25QE',
            otherDesc: "Perfect for climbing, riding, skiing, cave exploration, outward bound training, etc. Made of premium quality EPS, shockproof and wear resistance, super durable and very light to wear. The outer hard inner soft structure can effectively disperse the external force and absorb the impact force. Protecting the safety of the user's life. Rotate the adjusting roll to adjust size and fit your head size, convenient for you."

        // }

    },
    {
        id: 13,
        productName: 'Strauss UVX',
        price: 999,
        productImg: helmet4,
        category:'Helmet',
        // description: {
            brand: 'Firefox',
            color: 'blue',
            weight: 0.515,
            materials: ['Carbon Fibre','plastic'],
            frame: null,
            crank: null,
            videoSrc: 'https://www.youtube.com/embed/uBe2AkbL9bU',
            otherDesc: "Perfect for climbing, riding, skiing, cave exploration, outward bound training, etc. Made of premium quality EPS, shockproof and wear resistance, super durable and very light to wear. The outer hard inner soft structure can effectively disperse the external force and absorb the impact force. Protecting the safety of the user's life. Rotate the adjusting roll to adjust size and fit your head size, convenient for you."

        // }

    },
    {
        id: 14,
        productName: 'Prevail 3 HARDHEAD',
        price: 1999,
        productImg: helmet5,
        category:'Helmet',
        // description: {
            brand: 'Firefox',
            color: 'blue',
            weight: 0.15,
            materials: ['Carbon Fibre','plastic'],
            frame: null,
            crank: null,
            videoSrc: 'https://www.youtube.com/embed/POFyNtq5z5E',
            otherDesc: "Perfect for climbing, riding, skiing, cave exploration, outward bound training, etc. Made of premium quality EPS, shockproof and wear resistance, super durable and very light to wear. The outer hard inner soft structure can effectively disperse the external force and absorb the impact force. Protecting the safety of the user's life. Rotate the adjusting roll to adjust size and fit your head size, convenient for you."

        // }

    },
    {
        id: 15,
        productName: 'Hero StrengthMax',
        price: 2608,
        productImg: helmet6,
        category:'Helmet',
        // description: {
            brand: 'Firefox',
            color: 'blue',
            weight: 0.250,
            materials: ['Carbon Fibre','plastic'],
            frame: null,
            crank: null,
            videoSrc: 'https://www.youtube.com/embed/POFyNtq5z5E',
            otherDesc: "Perfect for climbing, riding, skiing, cave exploration, outward bound training, etc. Made of premium quality EPS, shockproof and wear resistance, super durable and very light to wear. The outer hard inner soft structure can effectively disperse the external force and absorb the impact force. Protecting the safety of the user's life. Rotate the adjusting roll to adjust size and fit your head size, convenient for you."

        // }

    },
    {
        id: 16,
        productName: 'Syncros Tailor 2.0',
        price: 1464,
        productImg: botHold1,
        category:'bottle-holder',
        // description: {
            brand: 'Firefox',
            color: 'blue',
            weight: 0.15,
            materials: ['Fibre','plastic'],
            frame: null,
            crank: null,
            videoSrc: 'https://www.youtube.com/embed/2k2H_IwOMdc',
            otherDesc: "Perfect for climbing, riding, skiing, cave exploration, outward bound training, etc. Made of premium quality EPS, shockproof and wear resistance, super durable and very light to wear. The outer hard inner soft structure can effectively disperse the external force and absorb the impact force. Protecting the safety of the user's life. Rotate the adjusting roll to adjust size and fit your head size, convenient for you."

        // }

    },
    {
        id: 17,
        productName: 'Montra trekker',
        price: 899,
        productImg: botHold2,
        category:'bottle-holder',
        // description: {
            brand: 'Montra',
            color: 'blue',
            weight: 0.2,
            materials: ['Fibre','plastic'],
            frame: null,
            crank: null,
            videoSrc: 'https://www.youtube.com/embed/t8L3M5cHpRU',
            otherDesc: " Versatile and practical - this bottle cage is available for being fixed onto any bars, such as handlebar, down tube, fork, front pipe of bike. \n Expanded size - this quick release bottle cage fits for most standard-sized water bottles. 2.5 inch - 3.3 inch bottle in diameter. No tool needed - the clamp of the bottle cage is designed for easy to installation and remove, no tool needed. Holds water bottles during cycling. Also fit many other types of vehicles and Convenient for you to drink water when you are thirsty. Upgraded grip - this bottle cage is upgraded clamp with a rubber pad and made by plastic"

        // }

    },
    {
        id: 18,
        productName: 'Firefox JTHD-5565',
        price: 1909,
        productImg: botHold3,
        category:'bottle-holder',
        // description: {
            brand: 'Firefox',
            color: 'blue',
            weight: 0.15,
            materials: ['Fibre','plastic'],
            frame: null,
            crank: null,
            videoSrc: 'https://www.youtube.com/embed/BbVGT2bfNAE',
            otherDesc: "Expanded size - this quick release bottle cage fits for most standard-sized water bottles. 2.5 inch - 3.3 inch bottle in diameter. No tool needed - the clamp of the bottle cage is designed for easy to installation and remove, no tool needed. Versatile and practical - this bottle cage is available for being fixed onto any bars, such as handlebar, down tube, fork, front pipe of bike. Holds water bottles during cycling. Also fit many other types of vehicles and Convenient for you to drink water when you are thirsty. Upgraded grip - this bottle cage is upgraded clamp with a rubber pad and made by plastic"

        // }

    },
]